/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignAclStorePathParams, CampaignAclStoreResponse } from '../types/CampaignAclStore'

/**
 * POST /campaigns/:campaign/access/:user
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAclController.php CampaignAclController::store
 */
export async function campaignAclStore(
	campaign: CampaignAclStorePathParams['campaign'],
	user: CampaignAclStorePathParams['user'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignAclStoreResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/access/${user}`, undefined, config)
}
